module.exports = __webpack_public_path__ + "static/media/WHT-HUSD.6f20ef06.png";